export default "__VITE_ASSET__4fe98a90__"